<div class="accordion accordion-default" [ngClass]="{'-opened': isOpen, '-default': type === 'default', '-side': type === 'side'}">
  <div class="accordion-heading" role="tab">
		<span class="accordion-heading_title">
			<a tabindex="0" *ngIf="heading" routerLink="{{'/' + link}}" routerLinkActive="-active" (click)="onToggleClick($event)">
				<span>{{ heading }}</span>
			</a>
      <div class="accordion-heading_icon" [style.display]="accordion.showArrows ? '' : 'none'" *ngIf="hasChildren">
				<i class="fa fa-chevron-right font-medium-3"></i>
			</div>
			<ng-content select="accordion-heading"></ng-content>
		</span>
  </div>
  <div class="accordion-content" *ngIf="hasChildren" [@slide]='isOpen ? "down" : "up"'>
    <div class="accordion-content_body">
      <ng-content></ng-content>
    </div>
  </div>
</div>
